import './track_indicators.scss'

import { useParticipantManager } from 'contexts/participant_manager_context'
import { ScreenOnIcon, VideoOnIcon } from 'images/index'
import React from 'react'
import { useSelector } from 'react-redux'
import { Participant } from 'twilio-video'

import { cn } from 'util/cn'

import { getCurrentTeammateHandle } from '../../../reduxes/slices/current/selectors'
import { useIsLocalParticipant } from '../participant_manager/use_is_local_participant'
import { SCREEN_SHARE_VIDEO_NAME } from '../util/web_rtc_config'
import { AudioIndicator } from './audio_indicator'
import { useAudioTrack } from './use_audio_track'
import { useVideoTrack } from './use_video_track'
import {css} from "design";

export type TrackIndicatorsProps = {
  participant: Participant
  handle: string
} & React.HTMLAttributes<HTMLUListElement>

export const TrackIndicators = ({
  participant,
  handle,
  className,
  ...props
}: TrackIndicatorsProps) => {
  const isLocalTwilioParticipant = useIsLocalParticipant(participant)
  const currentTeammateHandle = useSelector(getCurrentTeammateHandle)
  const isLocalParticipant =
    isLocalTwilioParticipant || handle === currentTeammateHandle
  const { localTrackData: participantManagerLocalTrackData = {} } =
    useParticipantManager()

  const localTrackData: any = isLocalParticipant
    ? participantManagerLocalTrackData
    : {}
  const {
    unpublishedAudioTrack,
    unpublishedVideoTrack,
    unpublishedScreenShareTrack,
  } = localTrackData

  const publishedAudioTrack = useAudioTrack(participant)
  const publishedVideoTrack = useVideoTrack(participant)
  const publishedScreenShareTrack = useVideoTrack(
    participant,
    SCREEN_SHARE_VIDEO_NAME,
  )

  const audioTrack = publishedAudioTrack || unpublishedAudioTrack
  const videoTrack = publishedVideoTrack || unpublishedVideoTrack
  const screenShareTrack =
    publishedScreenShareTrack || unpublishedScreenShareTrack

  return (
    <ul className={cn('topic__calls__trackindicator', className)} {...props}>
      {videoTrack && (
        <li className="topic__calls__trackindicator__item">
          <VideoOnIcon />
        </li>
      )}
      {screenShareTrack && (
        <li className={cn("topic__calls__trackindicator__item", screenShareIndicator())}>
          <ScreenOnIcon />
        </li>
      )}
      <li className="topic__calls__trackindicator__item">
        <AudioIndicator audioTrack={audioTrack} />
      </li>
    </ul>
  )
}

const screenShareIndicator = css({
  svg: {
    g: {
      path: {
        fill: '$foreground',
      }
    }
  },
})
